import React from 'react'
import moment from 'moment'
import { keys, includes, isObject, isArray, isBoolean } from 'lodash'

import { getText, getLocale, getTextWithTokens } from '../lib/text.js'

export const getPropTranslation = prop => {
  const r = getText(`prop_${prop}`, "es", true) || getText(`${prop}`, "es", false)
  if (!r) {
    console.log(`couldnt find prop_${prop} nor ${prop}`)
  }
  if (r === "null") {
    console.log(`prop_${prop} nor ${prop}: got "null"`)
  }
  return r || prop
}

function renderObjectAdding(keyOfObject, object) {
  return (
    <li key={keyOfObject}>
      {getTextWithTokens("Se ha añadido $$ con:", [getText(keyOfObject)])}
      <ul>
        {
          keys(object).map(key => {
            if (includes(key, "__")) return ""
            else return (<li
              key={key}
            >
              <i>
                {getText(key)}
              </i>
              {
                (object[key] === true && <span style={{ color: "green" }}> {getText("activado")}</span>)
                || (object[key] === false && <span style={{ color: "red" }}> {getText("desactivado")}</span>)
                || `: ${getText(object[key])}`
              }
            </li>)
          })
        }
      </ul>
    </li>
  )
}

function renderElementAdding(keyOfElement, element) {
  return (
    <li key={keyOfElement}>
    Se ha
      {
        (element === true && <span style={{ color: "green" }}> {getText("activado")} </span>)
        || (element === false && <span style={{ color: "red" }}> {getText("desactivado")} </span>)
        || " añadido "
      }
      <i>{getText(keyOfElement)}</i>
      {`${typeof (element) === "boolean" ? "" : `: ${getText(element)}`}`}
    </li>)
}

function renderAdding(keyOfElement, element) {
  if (isObject(element) && !isArray(element)) {
    return renderObjectAdding(keyOfElement, element)
  }
  else {
    return renderElementAdding(keyOfElement, element)
  }
}

export function getDay(index, agenda) {
  let day = 0
  for (let i = 0; i < index; i++) {
    if (agenda[i].type == "day") day += 1
  }
  return day
}

export function renderSeparator(date) {
  return (<h1>
    {moment(date).locale(getLocale()).calendar(null, {
      sameDay: `[${getText("Hoy")}]`,
      lastDay: `[${getText("Ayer")}]`,
      lastWeek: getText('[El] dddd [pasado] (DD/MM/YYYY)'),
      sameElse: 'DD/MM/YYYY'
    })}
  </h1>)
}

export function renderModification(prop, oldValue, newValue) {
  return (
    <li
      key={prop}
    >
      <b>{getPropTranslation(prop) ? getText(getPropTranslation(prop)) : getText(prop)}</b>
      {
        newValue === true
          ? <span style={{ color: "green" }}> {getText("activado")}</span>
          : isBoolean(oldValue) && !newValue
            ? <span style={{ color: "red" }}> {getText("desactivado")}</span>
            : getTextWithTokens(` se ha modificado de $$ a $$`, [getText(JSON.stringify(oldValue)), getText(JSON.stringify(newValue))])
      }
    </li>)
}

export function renderObject(object) {
  return (
    <ul>
      {
        keys(object).filter(key => !includes(key, "_")).map(c => {
          const change = object[c]
          if (isObject(change) && !isArray(change)) {
            return [
              <li key={c}>
                {getText(" Se ha modificado ")}<i>{getText(c)}</i>
              </li>,
              renderObject(change)
            ]
          }
          else if (change.length == 1) {
            return renderAdding(c, change[0])
          }
          else return renderModification(c, change[0], change[1])
        })
      }
    </ul>
  )
}
